import { callFes } from '..';

export function validate(query: string, countryCode: string): Promise<{ query: string; address: any }> {
  return callFes.get(`address/validate`, true, {
    params: {
      query,
      countryCode,
    },
  });
}
